import ReactDOM from "react-dom";
import React from "react";
import HexModal from "./HexModal";
import ConfirmationModal from "./ConfirmationModal";

export function confirm(props) {
  ReactDOM.render(
    <HexModal>
      <ConfirmationModal {...props} />
    </HexModal>,
    document.getElementById("modal-container")
  );
}
